import { ErrorHandler, Injectable } from '@angular/core';

declare function cwr(operation: string, payload: any): void;

@Injectable()
export class CwrErrorHandler implements ErrorHandler {
  handleError(error: any) {
    cwr('recordError', error);
  }
}
